<template>
  <div>
    <article class="iv2-article" v-if="pageActive">
      <div v-if="indexOpenType === 1">
        <BaseTitle :items="items" />

        <!-- クーポン一覧 -->
        <LayoutList :coupon="coupon" :explanation="explanation" />

        <!-- ページネーション -->
        <div v-if="coupon.length > 0" class="theme__sub-bg">
          <BasePagination :last-page="lastPage" @pagination="pagination" />
        </div>
      </div>

      <Error404 v-else-if="indexOpenType === 0" />
    </article>

    <div v-if="loading">
      <BaseLoading />
    </div>
  </div>
</template>

<script>
import BaseTitle from "@/components/items/BaseTitle.vue";
import LayoutList from "./components/LayoutList.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";
import BasePagination from "@/components/items/BasePagination.vue";
import Error404 from "@/components/systems/Page404.vue";
import Meta from "@/mixins/MetaSettable";

export default {
  components: {
    BaseTitle,
    LayoutList,
    BaseLoading,
    BasePagination,
    Error404,
  },

  mixins: [Meta],

  data() {
    return {
      coupon: [],
      items: {
        title: "",
        subtitle: "",
        header_type: "text_only",
      },
      lastPage: 1,
      sortPage: "",
      explanation: "",
      indexOpenType: "",
      pageActive: false,
      loading: true,
    };
  },

  mounted() {
    this.getCoupons();
  },

  methods: {
    getCoupons() {
      const couponsRepository = this.$repository.get("coupons");
      const coupons = couponsRepository.index(this.sortPage);
      const self = this;
      coupons
        .then((result) => {
          const res = result.data.response;
          self.coupon = res.data;
          self.items.title = res.title;
          self.items.subtitle = res.subtitle;
          self.lastPage = res.last_page;
          self.explanation = res.explanation;
          if (self.$route.query.mode == "preview") {
            self.indexOpenType = 1;
          } else {
            self.indexOpenType = res.open_type;
          }
        })
        .catch((error) => {
          console.error(error);
          self.indexOpenType = 0;
        })
        .finally(() => {
          self.loading = false;
          self.pageActive = true;
          window.scrollTo({
            top: 0,
          });
        });
    },

    pagination(page) {
      this.loading = true;
      if (page >= 1 && page <= this.lastPage) {
        this.sortPage = page;
        this.getCoupons();
      }
    },
  },
};
</script>

<style lang="scss"></style>
